import { Component, OnChanges, inject, ChangeDetectionStrategy, input, output } from '@angular/core';
import {MatIcon} from "@angular/material/icon";

import {ReactiveFormsModule} from "@angular/forms";
import {GuruEntity} from "../../../../model/guru-entity";
import {ConfigurationSection, UserStateService} from "../../../../services/user-state.service";
import {ModelService} from "../../../../services/model-service";
import {SelectionUtils} from "../../../selection-utils";

@Component({
    selector: 'app-sa-res-options',
    imports: [
    MatIcon,
    ReactiveFormsModule
],
    templateUrl: './sa-res-options.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: './sa-res-options.component.css'
})
export class SaResOptionsComponent implements OnChanges {
  private readonly modelService = inject(ModelService);
  private readonly userStateService = inject(UserStateService);


  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  unitVoltageSelection!: GuruEntity;
  controlsSelection!: GuruEntity;
  cabinetSelection!: GuruEntity;
  blowerMotorSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.OPTIONS;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.unitVoltageSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USUnitVoltage');
    this.controlsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USControlOptions');
    this.cabinetSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCabinet');
    this.blowerMotorSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USBlowerMotor');
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    entity.Value = newValue;
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
